module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"examsFor":"Prüfungen für {name}"},"en":{"examsFor":"Exams for {name}"}}')
  delete Component.options._Ctor
}
